/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ViewStyleFromJSON(json) {
    return ViewStyleFromJSONTyped(json, false);
}
export function ViewStyleFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'backgroundColor': !exists(json, 'background_color') ? undefined : json['background_color'],
        'padding': !exists(json, 'padding') ? undefined : json['padding'],
        'borderRadius': !exists(json, 'border_radius') ? undefined : json['border_radius'],
    };
}
export function ViewStyleToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'background_color': value.backgroundColor,
        'padding': value.padding,
        'border_radius': value.borderRadius,
    };
}
//# sourceMappingURL=ViewStyle.js.map